<template>
  <div>
    <div class="header pb-8 pt-5 pt-lg-6 d-flex align-items-center profile-header">
      <b-container fluid>
        <!-- Mask -->
        <span class="mask"></span>
        <!-- Header container -->
        <h1 class="text-center">Panel de Configuración</h1>
        <b-container fluid class="d-flex align-items-center">
          <b-row >
            <b-col lg="7" md="10">
            </b-col>
          </b-row>
        </b-container>
      </b-container>
    </div>

    <b-container fluid class="mt--6">
      <b-row>
        <b-col xl="12" class="order-xl-1">
          <card>
            <b-row align-v="center" slot="header" >
              <b-col cols="8">
                <h3 class="mb-0">Crear hospital</h3>
              </b-col>
            </b-row>

            <b-form @submit.prevent="updateProfile">
              <base-alert v-if="success === true" type="success" icon="ni ni-like-2 ni-lg" dismissible>
                <strong>¡Bien hecho!</strong> El hospital se creo existosamente.
              </base-alert>
              <base-alert v-if="success === false" type="danger" icon="ni ni-like-2 ni-lg" dismissible>
                <strong>¡Error!</strong> {{error}}
              </base-alert>
              <h6 class="heading-small text-muted mb-4">Información del hospital</h6>

              <div class="pl-lg-4">
                <b-row>
                  <b-col lg="6">
                    <base-input
                      type="text"
                      label="Nombre del hospital"
                      placeholder="Nombre"
                      v-model="nameHospital"
                      name="Nombre"
                      required
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6">
                    <base-input
                      type="text"
                      label="Titulo"
                      placeholder="Titulo del proyecto"
                      v-model="titleHospital"
                      name="Nombre"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6">
                    <base-input
                      type="text"
                      label="Correo electrónico para notificaciones"
                      placeholder="E-mail"
                      v-model="mail"
                      name="qty"
                    >
                    </base-input>
                  </b-col>
                </b-row>
                <hr>
                <b-row>
                  <b-col lg="6">
                    <base-input
                      type="text"
                      label="Cantidad de filipinas"
                      placeholder="Cantidad"
                      v-model="qtyScrubs"
                      name="qty"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6">
                    <base-input
                      type="text"
                      label="Cantidad de pantalones"
                      placeholder="Cantidad"
                      v-model="qtyPants"
                      name="qty"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6">
                    <base-input
                      type="text"
                      label="Cantidad de chamarras"
                      placeholder="Cantidad"
                      v-model="qtyJackets"
                      name="qty"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6">
                    <base-input
                      type="text"
                      label="Cantidad de batas"
                      placeholder="Cantidad"
                      v-model="qtyCoats"
                      name="qty"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6">
                    <base-input
                      type="text"
                      label="Cantidad de calzado"
                      placeholder="Cantidad"
                      v-model="qtyShoes"
                      name="qty"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6">
                    <base-input
                      type="text"
                      label="Cantidad de gorros"
                      placeholder="Cantidad"
                      v-model="qtyCaps"
                      name="qty"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6">
                    <base-input
                      type="text"
                      label="Cantidad de ordenes"
                      placeholder="Cantidad"
                      v-model="qtyOrders"
                      name="qtyOrders"
                    >
                    </base-input>
                  </b-col>
                </b-row>
                <hr>
                <b-row>
                  <b-col lg="6">
                    <label class="form-control-label" for="">Agregar Logotipo Portal</label><br>
                    <input type="file" class="form-control input-file" v-on:change="onFileChange" id="input" />
                  </b-col>
                  <b-col lg="6">
                    <base-input
                      type="text"
                      label="Máximo de carácteres por campo"
                      placeholder=""
                      v-model="maxChars"
                      name="maxChars"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6">
                    <base-input
                      type="text"
                      label="Mínimo de carácteres por campo"
                      placeholder=""
                      v-model="minChars"
                      name="minChars"
                    >
                    </base-input>
                  </b-col>
                </b-row>
              </div>
              <hr class="my-4">
              <h6 class="heading-small text-muted mb-4">Bordado Nombre</h6>
              <div class="pl-lg-4">
                <b-row>
                  <b-col class="mb-3" lg="6">
                    <multiselect
                      :show-labels="false"
                      v-model="embroidery"
                      :options="optionYN"
                      :multiple="false"
                      placeholder='Si/No'
                      name="Bordado"
                      required>
                    </multiselect>
                  </b-col>
                </b-row>
                <b-row v-if="embroidery == 'Si'">
                  <b-col class="mb-3" lg="6">
                    <base-input
                      type="text"
                      label="Precio"
                      placeholder=""
                      v-model="embroideryPrice"
                      name="embroideryPrice"
                    >
                    </base-input>
                  </b-col>
                  <b-col class="mb-3" lg="6">
                    <label class="form-control-label" for="">Colores bordado</label>
                    <multiselect
                      :show-labels="false"
                      v-model="embroideryColor"
                      :options="threadColors"
                      :multiple="false"
                      placeholder='Selecciona el color'
                      label="name"
                      track-by="id"
                      value-prop="id">
                    </multiselect>
                  </b-col>
                  <b-col class="mb-3" lg="6">
                    <label class="form-control-label" for="">Fuentes de bordado</label>
                    <multiselect
                      :show-labels="false"
                      v-model="embroideryFont"
                      :options="fonts"
                      :multiple="false"
                      placeholder='Selecciona la fuente'
                      label="name"
                      track-by="id"
                      value-prop="id">
                    </multiselect>
                  </b-col>
                  <b-col class="mb-3" lg="6">
                    <label class="form-control-label" for="">Posición de bordado <i>(Filipina)</i></label>
                    <multiselect
                      :show-labels="false"
                      v-model="embroideryPositionScrub"
                      :options="optionsPositionScrub"
                      :multiple="false"
                      placeholder='Selecciona la posicion'
                      label="text"
                      track-by="id"
                      value-prop="id">
                    </multiselect>
                  </b-col>
                  <b-col class="mb-3" lg="6">
                    <label class="form-control-label" for="">Posición de bordado<i>(Especialidad)</i></label>
                    <multiselect
                      :show-labels="false"
                      v-model="embroideryPositionSpeciality"
                      :options="optionsPositionScrub"
                      :multiple="false"
                      placeholder='Selecciona la posicion'
                      label="text"
                      track-by="id"
                      value-prop="id">
                    </multiselect>
                  </b-col>
                  <b-col class="mb-3" lg="6">
                    <label class="form-control-label" for="">Posición de bordado <i>(Pantalón)</i></label>
                    <multiselect
                      :show-labels="false"
                      v-model="embroideryPositionPants"
                      :options="optionsPositionPants"
                      :multiple="false"
                      placeholder='Selecciona la posicion'
                      label="text"
                      track-by="id"
                      value-prop="id">
                    </multiselect>
                  </b-col>
                  <b-col class="mb-3" lg="6">
                    <label class="form-control-label" for="">Posición de bordado <i>(Bata)</i></label>
                    <multiselect
                      :show-labels="false"
                      v-model="embroideryPositionCoat"
                      :options="optionsPositionCoat"
                      :multiple="false"
                      placeholder='Selecciona la posicion'
                      label="text"
                      track-by="id"
                      value-prop="id">
                    </multiselect>
                  </b-col>
                  <b-col class="mb-3" lg="6">
                    <label class="form-control-label" for="">Posición de bordado <i>(Chamarra)</i></label>
                    <multiselect
                      :show-labels="false"
                      v-model="embroideryPositionJacket"
                      :options="optionsPositionJacket"
                      :multiple="false"
                      placeholder='Selecciona la posicion'
                      label="text"
                      track-by="id"
                      value-prop="id">
                    </multiselect>
                  </b-col>
                </b-row>
              </div>
              <h6 class="heading-small text-muted mb-4">Bordado Logotipo</h6>
              <div class="pl-lg-4">
                <b-row>
                  <b-col class="mb-3" lg="6">
                    <multiselect
                      :show-labels="false"
                      v-model="embroideryLogo"
                      :options="optionYN"
                      :multiple="false"
                      placeholder='Si/No'
                      name="Bordado"
                      required>
                    </multiselect>
                  </b-col>
                </b-row>
                <b-row v-if="embroideryLogo == 'Si'">
                  <b-col class="mb-3" lg="6">
                    <base-input
                      type="text"
                      label="Precio"
                      placeholder=""
                      v-model="logoPrice"
                      name="logoPrice"
                    >
                    </base-input>
                  </b-col>
                  <b-col class="mb-3" lg="7">
                    <label class="form-control-label" for="">Agregar Logotipo</label><br>
                    <input type="file" class="form-control input-file" v-on:change="onFileChangeBordado" id="input" />
                  </b-col>
                  <b-col class="mb-3" lg="6">
                    <label class="form-control-label" for="">Posición de logo <i>(Filipina)</i></label>
                    <multiselect
                      :show-labels="false"
                      v-model="embroideryPositionScrubLogo"
                      :options="optionsPositionScrub"
                      :multiple="false"
                      placeholder='Selecciona la posicion'
                      label="text"
                      track-by="id"
                      value-prop="id">
                    </multiselect>
                  </b-col>
                  <b-col class="mb-3" lg="6">
                    <label class="form-control-label" for="">Posición de logo <i>(Pantalón)</i></label>
                    <multiselect
                      :show-labels="false"
                      v-model="embroideryPositionPantsLogo"
                      :options="optionsPositionPants"
                      :multiple="false"
                      placeholder='Selecciona la posicion'
                      label="text"
                      track-by="id"
                      value-prop="id">
                    </multiselect>
                  </b-col>
                  <b-col class="mb-3" lg="6">
                    <label class="form-control-label" for="">Posición de logo <i>(Bata)</i></label>
                    <multiselect
                      :show-labels="false"
                      v-model="embroideryPositionCoatLogo"
                      :options="optionsPositionCoat"
                      :multiple="false"
                      placeholder='Selecciona la posicion'
                      label="text"
                      track-by="id"
                      value-prop="id">
                    </multiselect>
                  </b-col>
                  <b-col class="mb-3" lg="6">
                    <label class="form-control-label" for="">Posición de logo <i>(Chamarra)</i></label>
                    <multiselect
                      :show-labels="false"
                      v-model="embroideryPositionJacketLogo"
                      :options="optionsPositionJacket"
                      :multiple="false"
                      placeholder='Selecciona la posicion'
                      label="text"
                      track-by="id"
                      value-prop="id">
                    </multiselect>
                  </b-col>
                  
                </b-row>
              </div>
              
              
              <b-button type="submit" variant="primary" class="mt-4">Crear hospital</b-button>
            </b-form>
          </card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import axios from 'axios'
import qs from 'qs'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      nameHospital: '',
      titleHospital: '',
      token: '',
      user: '',
      success: '',
      error: '',
      file: '',
      fileLogo: '',
      logoPrice: 0,
      embroideryPrice: 0,
      embroidery: '',
      embroideryLogo: '',
      embroideryPositionScrub: "",
      embroideryPositionPants: "",
      embroideryPositionCoat: "",
      embroideryPositionJacket: "",
      embroideryPositionSpeciality: "",
      embroideryPositionScrubLogo: "",
      embroideryPositionPantsLogo: "",
      embroideryPositionCoatLogo: "",
      embroideryPositionJacketLogo: "",
      embroideryColor: "",
      embroideryFont: "",
      qtyScrubs: '',
      qtyPants: '',
      qtyJackets: '',
      qtyCaps: '',
      qtyShoes: '',
      qtyCoats: '',
      qtyOrders: '',
      maxChars: 0,
      minChars: 0,
      mail: '',
      fonts: [],
      threadColors: [],
      optionYN: ['Si', 'No'],
      optionsPositionScrub: [
          { text: 'Frente Izquierdo', position: 'position: absolute; background: #F15E1A; height: 10px;width: 20px;top: 31%;left: 58%;'},
          { text: 'Frente Derecho', position: 'position: absolute; background: #F15E1A; height: 10px;width: 20px;top: 31%;left: 33%;'},
          { text: 'Manga Izquierda', position: 'position: absolute; background: #F15E1A; height: 10px;width: 20px;top: 31%;left: 71%;'},
          { text: 'Manga Derecha', position: 'position: absolute; background: #F15E1A; height: 10px;width: 20px;top: 31%;left: 21%;'},
          { text: 'Otro', position: ''}
      ],
      optionsPositionPants: [
          { text: 'Pierna Izquierda', position: 'position: absolute; background: #F15E1A; height: 10px;width: 20px;top: 19%;left: 56%;'},
          { text: 'Pierna Derecha', position: 'position: absolute; background: #F15E1A; height: 10px;width: 20px;top: 19%;left: 37%;'},
          { text: 'Otro', position: ''}
      ],
      optionsPositionCoat: [
          { text: 'Frente Izquierdo', position: 'position: absolute; background: #F15E1A; height: 10px;width: 20px;top: 23%;left: 56%;'},
          { text: 'Frente Derecho', position: 'position: absolute; background: #F15E1A; height: 10px;width: 20px;top: 23%;left: 36%;'},
          { text: 'Manga Izquierda', position: 'position: absolute; background: #F15E1A; height: 10px;width: 20px;top: 23%;left: 65%;'},
          { text: 'Manga Derecha', position: 'position: absolute; background: #F15E1A; height: 10px;width: 20px;top: 23%;left: 27%;'},
          { text: 'Espalda', position: 'position: absolute; background: #F15E1A; height: 10px;width: 20px;top: 10%;left: 46%;', back: true},
          { text: 'Otro', position: ''}
      ],
      optionsPositionJacket: [
          { text: 'Frente Izquierdo', position: 'position: absolute; background: #F15E1A; height: 10px;width: 20px;top: 31%;left: 58%;'},
          { text: 'Frente Derecho', position: 'position: absolute; background: #F15E1A; height: 10px;width: 20px;top: 31%;left: 33%;'},
          { text: 'Manga Izquierda', position: 'position: absolute; background: #F15E1A; height: 10px;width: 20px;top: 31%;left: 71%;'},
          { text: 'Manga Derecha', position: 'position: absolute; background: #F15E1A; height: 10px;width: 20px;top: 31%;left: 21%;'},
          { text: 'Espalda', position: 'position: absolute; background: #F15E1A; height: 10px;width: 20px;top: 14%;left: 46%;', back: true},
          { text: 'Otro', position: ''}
      ],
    }
  },
  created() {
    this.token = localStorage.getItem('token')
    this.user = localStorage.getItem('id_user')
    axios
    .post(
      process.env.VUE_APP_ROUTE_BACKEND_API+'admin_api.php',
      qs.stringify({ api_token: this.token, user_id: this.user, option: 'get_catalogs'}),
    )
    .then((response) => {
      if (!response.data.error.code && response.data.models) {
          let tempThreadColors = [], tempFonts = []
          
          Object.keys(response.data.threadcolors).map((key) => [response.data.threadcolors[key]]).map(function(value) {
            tempThreadColors.push(value[0])
          })
          Object.keys(response.data.fonts).map((key) => [response.data.fonts[key]]).map(function(value) {
            tempFonts.push(value[0])
          })
          this.fonts =  tempFonts
          this.threadColors =  tempThreadColors
      }
    })
    .catch((err) => {
      console.log(err)
    })
  },
  methods: {
    updateProfile() {
      this.token = localStorage.getItem('token')
      this.user = localStorage.getItem('id_user')
      let formData = new FormData()
      if(this.nameHospital) {
        formData.append('user_id', this.user)
        formData.append('api_token', this.token)
        formData.append('option', 'create_hospital')
        formData.append('h_name', this.nameHospital)
        formData.append('h_title', this.titleHospital)
        if(this.file){
          formData.append('h_image', this.file)
        }
        if(this.embroidery == 'Si'){
          formData.append('h_embroidery', this.embroidery)
          formData.append('h_embroidery_color', JSON.stringify(this.embroideryColor))
          formData.append('h_embroidery_font', JSON.stringify(this.embroideryFont))
          formData.append('h_embroidery_position_scrub', JSON.stringify(this.embroideryPositionScrub))
          formData.append('h_embroidery_position_pants', JSON.stringify(this.embroideryPositionPants))
          formData.append('h_embroidery_position_coat', JSON.stringify(this.embroideryPositionCoat))
          formData.append('h_embroidery_position_jacket', JSON.stringify(this.embroideryPositionJacket))
          formData.append('h_embroidery_position_speciality', JSON.stringify(this.embroideryPositionSpeciality))
        }
        if(this.embroideryLogo == 'Si'){
          if(this.fileLogo){
            formData.append('h_image_logo', this.fileLogo)
          }
          formData.append('h_embroidery_l', this.embroideryLogo)
          formData.append('h_embroidery_position_scrub_l', JSON.stringify(this.embroideryPositionScrubLogo))
          formData.append('h_embroidery_position_pants_l', JSON.stringify(this.embroideryPositionPantsLogo))
          formData.append('h_embroidery_position_coat_l', JSON.stringify(this.embroideryPositionCoatLogo))
          formData.append('h_embroidery_position_jacket_l', JSON.stringify(this.embroideryPositionJacketLogo))
        }
        formData.append('e_price', this.embroideryPrice)
        formData.append('l_price', this.logoPrice)
        formData.append('h_qty_f', this.qtyScrubs)
        formData.append('h_qty_p', this.qtyPants)
        formData.append('h_qty_c', this.qtyJackets)
        formData.append('h_qty_b', this.qtyCoats)
        formData.append('h_qty_g', this.qtyCaps)
        formData.append('h_qty_z', this.qtyShoes)
        formData.append('h_qty_o', this.qtyOrders)
        formData.append('h_mail', this.mail)
        formData.append('h_max_chars', this.maxChars)
        formData.append('h_min_chars', this.minChars)
        axios
        .post(
          process.env.VUE_APP_ROUTE_BACKEND_API+'admin_api.php', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          if (!response.data.error.code) {
            this.success = true
          } else {
            this.success = false
            this.error = response.data.error.description
          }
        })
        .catch((err) => {
          console.log(err)
        })
      } else {
        this.success = false
        this.error = ''
      }
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length)
        return;
      this.file =  files[0]
      this.createImage(files[0])
    },
    onFileChangeBordado(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length)
        return;
      this.fileLogo =  files[0]
      this.createImage(files[0])
    },
    createImage(file) {
      var image = new Image()
      var reader = new FileReader()
      var vm = this;

      reader.onload = (e) => {
        vm.image = e.target.result
      };
      reader.readAsDataURL(file)
    },
  },
};
</script>
<style>
.input-file::file-selector-button {
    font-weight: bold;
    color: transparent;
    padding: 0;
    border: none;
    background: transparent;
    background: url('../../../assets/icn_attach.svg');
    background-repeat: no-repeat;
    border-radius: 3px;
    position: absolute;
    right: -5%;
}
</style>
